import { buildMockPromise } from "../api/helpers";
import {
  ThresholdDashboardEntry,
  WorkflowDashboardEntry,
  WorkflowInfoApi,
  WorkflowRun,
  WORKFLOW_STEP_STATUS_ENUM,
} from "../api/Workflows";

export const workflowList: WorkflowInfoApi[] = [
  {
    workflow_config_uuid: "ed2b9c55-8644-437b-8289-102017350cfd",
    name: "Express Check",
  },
];

export async function getWorkflowInfoListMock(): Promise<WorkflowInfoApi[]> {
  return await buildMockPromise<WorkflowInfoApi[]>(workflowList);
}

export const exampleWorkflowRun: WorkflowRun = {
  external_id: "08a9fb9e-ef5a-45f9-9771-42d197728158",
  name: "MAIN WORK FLOW",
  payload: "{}",
  status: "IN_PROGRESS",
  due_date: new Date().toISOString(),
  due_date_updated: false,
  error_type: "",
  error_message: "",
  locked_by: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  lock_expire: new Date(),
  company_uuid: "81145b8f1d114df79fe72fb03401db44",
  sla_met: true,
};

export async function getWorkflowLock(workflowRunUUID: string) {
  return await buildMockPromise<WorkflowRun>(
    {
      ...exampleWorkflowRun,
      external_id: workflowRunUUID,
    },
    2000
  );
}

function randomStepNameDashboard() {
  if (Math.random() > 0.85) {
    return null;
  }
  const statuses = Object.values(WORKFLOW_STEP_STATUS_ENUM);
  return statuses[Math.floor(Math.random() * statuses.length)];
}

export async function getWorkflowDashboardMock(
  numItems: number
): Promise<WorkflowDashboardEntry[]> {
  const list: WorkflowDashboardEntry[] = [];
  for (let i = 1; i <= numItems; i++) {
    list.push({
      date: new Date(),
      past_due: false,
      step_name: randomStepNameDashboard(),
      count: Math.floor(Math.random() * 200),
    });
  }

  return list;
}

export async function getWorkflowThresholdDashboardMock(
  numItems: number
): Promise<ThresholdDashboardEntry[]> {
  const list: ThresholdDashboardEntry[] = [];
  for (let i = 1; i <= numItems; i++) {
    list.push({
      days: Math.floor(Math.random() * 6),
      step_name: randomStepNameDashboard(),
      threshold: Math.floor(Math.random() * 200),
    });
  }

  return list;
}
